import React from 'react';
import { useTranslation } from 'react-i18next';
import { ModalContent } from 'fronton-react';
import {
  List,
  ListItem,
  ModalHeader,
  Typography,
} from 'common/components';
import {
  guaranteeGoods,
  guaranteeModalContent,
  guaranteeModalList,
  guaranteeModalSubtitle,
} from './guarantee-modal-styles';

export const GuaranteeModal = () => {
  const { t } = useTranslation();

  return (
    <>
      <ModalHeader title={t('utp-section.guarantee.modal-title-first')} />
      <ModalContent className={guaranteeModalContent}>
        <Typography className={guaranteeGoods} variant="m" size="body_long">
          {t('utp-section.guarantee.modal-description-first')}
        </Typography>
        <List className={guaranteeModalList} listStyle="disc">
          <ListItem>
            <Typography variant="m" size="body_long">
              {t('utp-section.guarantee.modal-item-first')}
            </Typography>
          </ListItem>
          <ListItem>
            <Typography variant="m" size="body_long">
              {t('utp-section.guarantee.modal-item-second')}
            </Typography>
          </ListItem>
          <ListItem>
            <Typography variant="m" size="body_long">
              {t('utp-section.guarantee.modal-item-third')}
            </Typography>
          </ListItem>
          <ListItem>
            <Typography variant="m" size="body_long">
              {t('utp-section.guarantee.modal-item-fourth')}
            </Typography>
          </ListItem>
        </List>

        <ModalHeader
          className={guaranteeModalSubtitle}
          title={t('utp-section.guarantee.modal-title-second')}
        />
        <Typography className={guaranteeGoods} variant="m" size="body_long">
          {t('utp-section.guarantee.modal-description-second')}
        </Typography>
        <List listStyle="disc">
          <ListItem>
            <Typography as="span" variant="m" size="body_long">
              {t('utp-section.guarantee.modal-item-fifth')}
            </Typography>
          </ListItem>
          <ListItem>
            <Typography as="span" variant="m" size="body_long">
              {t('utp-section.guarantee.modal-item-sixth')}
            </Typography>
          </ListItem>
        </List>
      </ModalContent>
    </>
  );
};
